"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeFilledInputStyles = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeFilledInputStyles = function makeFilledInputStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: tokens.colors.background.color,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          boxShadow: "none",
          "&:hover": {
            backgroundColor: tokens.colors.background.color,
            boxShadow: "none"
          },
          "&.Mui-focused": {
            backgroundColor: tokens.colors.background.color,
            boxShadow: "none"
          },
          '& + [class*="MuiFormHelperText-root"]': {
            marginLeft: primitives.spacings["2"]
          },
          "&.Mui-error": {
            marginLeft: 0,
            '& div[class*="MuiFilledInput-input"]': _defineProperty({
              borderRadius: "".concat(primitives.borderRadii.medium, " ").concat(primitives.borderRadii.medium, " 0 0"),
              boxShadow: tokens.effects["field-error"].boxShadow,
              padding: "calc(".concat(primitives.spacings["3"], "/2) ").concat(primitives.spacings["7"], " calc(").concat(primitives.spacings["3"], "/2) ").concat(primitives.spacings["2"])
            }, "&:hover, &:active:not(.Mui-disabled), &[aria-expanded='true'][class*=\"MuiSelect-filled\"]", {
              "&:not(.Mui-disabled):not(:focus):not(:focus-visible)": {
                borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(primitives.colors.detail.transparent),
                "& + input + .MuiSelect-icon": {
                  marginRight: primitives.spacings["1"]
                }
              }
            })
          },
          '& [class*="MuiSelect-icon"], [class*="MuiNativeSelect-icon"]': {
            color: tokens.colors["ink-on-background"].rgb,
            marginRight: primitives.spacings["1"],
            position: "absolute",
            right: 0,
            pointerEvents: "none"
          },
          '&:not(.Mui-disabled) [class*="MuiFilledInput-input"]:before': {
            left: 0,
            right: 0,
            bottom: 0,
            display: "block",
            height: "100%",
            content: "''",
            position: "absolute"
          }
        },
        input: {
          padding: "calc(".concat(primitives.spacings["3"], "/2) ").concat(primitives.spacings["2"]),
          borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(primitives.colors.detail.transparent),
          height: "auto",
          "&:focus, &:focus-visible": {
            borderRadius: "".concat(primitives.borderRadii.medium, " ").concat(primitives.borderRadii.medium, " 0 0"),
            boxShadow: tokens.effects["focus-ring-thin"].boxShadow,
            "&[aria-expanded='true']": {
              boxShadow: "none"
            }
          },
          "&[data-active='true']:not(.Mui-error)": {
            borderBottom: "2px solid ".concat(tokens.colors["ink-focus"].color)
          }
        },
        underline: {
          borderBottom: 0,
          "&:hover:before": {
            borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-hover"].color),
            left: primitives.spacings["2"]
          },
          "&:hover:focus-within:before": {
            borderBottom: 0
          },
          "&:before, &:after, &.Mui-disabled:before, &.Mui-error:before, &:focus:before, &:focus-visible:before, &:active:before": {
            borderBottom: 0
          }
        }
      }
    }
  };
};

exports.makeFilledInputStyles = makeFilledInputStyles;